









import { IsMens } from '@/utils/app-setting';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ErrorBanner extends Vue {
  @Prop({ default: () => '' }) public errorMsg!: string
  public isMens = IsMens()
  public errorIconPass = require(this.isMens
    ? '@/assets/icon_error_red.png'
    : '@/assets/icon_error_blue.png')
}
